module.exports = __webpack_public_path__ + "img/4movement.beb693f7.gif";